import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import BackgroundPageContent from 'src/components/BackgroundPageContent/BackgroundPageContent'
import BudgetsRequestContent from 'src/components/BudgetsRequestContent/BudgetsRequestContent'
import { selectBudgetsAllBudgetsMatch } from 'src/redux/selectors/router.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'

const BudgetsRequests: React.FC = () => {
  const appName = useSelector(selectAppName)
  const budgetsAllBudgetsMatch = useSelector(selectBudgetsAllBudgetsMatch)
  const allOrYour = budgetsAllBudgetsMatch ? 'All' : 'Your'

  return (
    <>
      <Helmet>
        <title>{`${allOrYour} Budgets | ${appName}`}</title>
        <meta
          name="description"
          content={`${allOrYour} Budgets page of ${appName}`}
        />
      </Helmet>
      <BackgroundPageContent noPadding>
        <BudgetsRequestContent />
      </BackgroundPageContent>
    </>
  )
}

export default BudgetsRequests
